import {
  Show,
  TextField,
  BooleanField,
  NumberField,
  DateField,
  FunctionField,
  RichTextField,
  TabbedShowLayout,
  Tab,
  ReferenceManyField,
  Datagrid,
} from 'react-admin';

export const CollectionShow = () => (
  <Show>
    <TabbedShowLayout>
      <Tab label="Основная информация">
        <TextField source="id" />
        <TextField source="name" label="Название" />
        <TextField source="slug" label="URL (slug)" />
        <RichTextField source="description" label="Описание" />
        <FunctionField
          label="Изображение"
          render={(record: any) => {
            if (record.image) {
              const thumbnail = record.image.thumbnails?.find((t: any) => t.variant === 'thumbnail');
              const imageUrl = thumbnail?.url || record.image.url;
              return (
                <img 
                  src={imageUrl} 
                  alt={record.name} 
                  style={{ width: 200, height: 200, objectFit: 'cover' }} 
                />
              );
            }
            return 'Нет изображения';
          }}
        />
        <NumberField source="sortOrder" label="Порядок сортировки" />
        <BooleanField source="isActive" label="Активна" />
        <FunctionField 
          label="Количество товаров" 
          render={(record: any) => record._count?.products || 0} 
        />
        <DateField source="createdAt" />
        <DateField source="updatedAt" />
      </Tab>
      
      <Tab label="SEO">
        <TextField source="metaTitle" label="Meta Title" />
        <TextField source="metaDescription" label="Meta Description" />
        <TextField source="metaKeywords" label="Meta Keywords" />
      </Tab>
      
      <Tab label="Товары">
        <ReferenceManyField
          reference="collection-products"
          target="collectionId"
          label="Товары в подборке"
        >
          <Datagrid>
            <TextField source="product.name" label="Название товара" />
            <TextField source="product.slug" label="Slug товара" />
            <NumberField source="product.price" label="Цена" />
            <FunctionField
              label="Кастомное изображение"
              render={(record: any) => {
                if (record.customImage) {
                  const thumbnail = record.customImage.thumbnails?.find((t: any) => t.variant === 'thumbnail');
                  const imageUrl = thumbnail?.url || record.customImage.url;
                  return (
                    <img 
                      src={imageUrl} 
                      alt="Custom image" 
                      style={{ width: 50, height: 50, objectFit: 'cover' }} 
                    />
                  );
                }
                return 'Нет изображения';
              }}
            />
            <NumberField source="sortOrder" label="Порядок" />
            <DateField source="createdAt" />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);
